import { useEffect } from "react";
import { Link } from "react-router-dom";
import { PackageInformation } from "src/models";
import LazyLoad from "vanilla-lazyload";
import phPackage from "src/assets/static/img/main/icons/ph_package.png";
import { _ } from "src/services";

export const PackageBox: React.FC<PackageInformation> = ({ image, id, title, description, purchaseType }) => {


    useEffect(() => {
        const lazyload = new LazyLoad({
            elements_selector: ".lazy.p" + id,
            callback_error: (element: HTMLElement) => {
                const placeholder = element.getAttribute("data-placeholder");
                if (placeholder) element.setAttribute("src", placeholder);
            }
        });

        lazyload.update();

    }, [id]);

    return (
        <div className="package-box d-flex flex-column">
            <div className="header d-flex align-items-center">
                <img alt="" data-src={image}
                    data-placeholder={phPackage}
                    src={phPackage}
                    className={`logo lazy p${id}`} />
                <span>{title}</span>
            </div>
            <ul className="description">
                {description.map((x, i) => <li key={i}>{x}</li>)}
            </ul>
            <Link to={`/subscription/${id}`} className="btn btn-packages">
                {purchaseType === "renew" ? _("renew") : _("selectAndContinue")}
            </Link>
        </div>
    );
};